export default __webpack_public_path__ + "static/media/option-arrow.026f4e3f.svg";